import { Injectable } from '@angular/core';

import {
  SPONSOR_AVOID_NO_RESTRICTIONS_VALUE,
  SPONSOR_COMPANY_ACTION_NONE_VALUE,
  SPONSOR_SPORT_ANY_VALUE,
} from '../constants/sponsor-onboarding.constants';
import { SponsorAvoidPreference } from '../enums/sponsor-avoid-preference.enum';
import { SponsorCompanyAction } from '../enums/sponsor-company-action.enum';
import { SponsorSportInterest } from '../enums/sponsor-sport-interest.enum';

@Injectable({
  providedIn: 'root',
})
export class SponsorOnboardingSelectionService {
  public resolveCompanyActionSelection(
    current: SponsorCompanyAction[],
    clicked: SponsorCompanyAction,
  ): SponsorCompanyAction[] {
    if (clicked === SPONSOR_COMPANY_ACTION_NONE_VALUE) {
      return current.includes(clicked) ? [] : [clicked];
    }
    const withoutNone = current.filter((value) => value !== SPONSOR_COMPANY_ACTION_NONE_VALUE);
    if (withoutNone.includes(clicked)) {
      return withoutNone.filter((value) => value !== clicked);
    }
    return [...withoutNone, clicked];
  }

  public resolveAvoidPreferenceSelection(
    current: SponsorAvoidPreference[],
    clicked: SponsorAvoidPreference,
  ): SponsorAvoidPreference[] {
    if (clicked === SPONSOR_AVOID_NO_RESTRICTIONS_VALUE) {
      return current.includes(clicked) ? [] : [clicked];
    }
    const withoutExclusive = current.filter((value) => value !== SPONSOR_AVOID_NO_RESTRICTIONS_VALUE);
    if (withoutExclusive.includes(clicked)) {
      return withoutExclusive.filter((value) => value !== clicked);
    }
    return [...withoutExclusive, clicked];
  }

  public resolveSportsInterestSelection(
    current: SponsorSportInterest[],
    clicked: SponsorSportInterest,
  ): SponsorSportInterest[] {
    if (clicked === SPONSOR_SPORT_ANY_VALUE) {
      return current.includes(clicked) ? [] : [clicked];
    }
    const withoutExclusive = current.filter((value) => value !== SPONSOR_SPORT_ANY_VALUE);
    if (withoutExclusive.includes(clicked)) {
      return withoutExclusive.filter((value) => value !== clicked);
    }
    return [...withoutExclusive, clicked];
  }

  public getDisabledCompanyActionValues(selected: SponsorCompanyAction[]): SponsorCompanyAction[] {
    if (selected.includes(SPONSOR_COMPANY_ACTION_NONE_VALUE)) {
      return Object.values(SponsorCompanyAction).filter(
        (value) => value !== SPONSOR_COMPANY_ACTION_NONE_VALUE,
      );
    }
    if (selected.length > 0) {
      return [SPONSOR_COMPANY_ACTION_NONE_VALUE];
    }
    return [];
  }

  public getDisabledSportsInterestValues(selected: SponsorSportInterest[]): SponsorSportInterest[] {
    if (selected.includes(SPONSOR_SPORT_ANY_VALUE)) {
      return Object.values(SponsorSportInterest).filter((value) => value !== SPONSOR_SPORT_ANY_VALUE);
    }
    if (selected.length > 0) {
      return [SPONSOR_SPORT_ANY_VALUE];
    }
    return [];
  }

  public getDisabledAvoidPreferenceValues(
    selected: SponsorAvoidPreference[],
  ): SponsorAvoidPreference[] {
    if (selected.includes(SPONSOR_AVOID_NO_RESTRICTIONS_VALUE)) {
      return Object.values(SponsorAvoidPreference).filter(
        (value) => value !== SPONSOR_AVOID_NO_RESTRICTIONS_VALUE,
      );
    }
    if (selected.length > 0) {
      return [SPONSOR_AVOID_NO_RESTRICTIONS_VALUE];
    }
    return [];
  }
}
